import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Con cookies HttpOnly, simplemente aseguramos que withCredentials esté habilitado
  // para todas las peticiones a la API
  
  if (req.url.includes('/api/')) {
    const authReq = req.clone({
      setHeaders: {
        'Content-Type': 'application/json'
      },
      withCredentials: true // Esto asegura que las cookies se envíen automáticamente
    });
    return next(authReq);
  }

  return next(req);
};
